import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponse } from '../dd_panel_patient_profiles/types.ts'

const getList = async <T>(): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>('/api/body_parts/')
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const bodyPartsApi = {
  getList
}
